import BaseCheckbox, { BaseCheckboxProps } from 'components/base-checkbox';
import styles from './styles.module.scss';

type CheckboxProps = Pick<
  BaseCheckboxProps,
  'checked' | 'onChange' | 'label' | 'labelPosition' | 'className' | "isDisabled"
>;

const Checkbox: React.FC<CheckboxProps> = (props) => {
  return <BaseCheckbox {...props} inputClassName={styles.input} markClassName={styles.checkmark} />;
};

export default Checkbox;
